import type { ReactNode } from 'react';

export function Panel({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <section className={`rounded-[10px] border border-line bg-panel ${className}`}>
      {children}
    </section>
  );
}

export function PanelHeader({ children }: { children: ReactNode }) {
  return (
    <header className="border-b border-line px-4 py-3 text-[11px] uppercase tracking-wider text-dim">
      {children}
    </header>
  );
}
